import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Suggest } from '@blueprintjs/select'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'

import styles from './inputSelect.module.scss'

class InputSelect extends Component {
    static propTypes = {
        /**
         * Icon to be shown on the right side of the select. Default show icon is
         * a chevron down
         */
        selectIcon: PropTypes.object,
        showRightIcon: PropTypes.bool,
        /**
         * Another element to be added on the right side
         */
        additionalRightElement: PropTypes.node,
    }

    static defaultProps = {
        selectIcon: faChevronDown,
        showRightIcon: true,
        filterable: true,
    }

    render() {
        const {
            selectIcon,
            showRightIcon,
            inputProps,
            additionalRightElement,
            filterable,
            ...other
        } = this.props

        return (
            <Suggest
                {...other}
                inputProps={{
                    ...inputProps,
                    readOnly: !filterable,
                    className: classNames(styles.select, {
                        [inputProps.className]: inputProps.className,
                        [styles.smallSelect]: inputProps.small,
                        [styles.normalSelect]:
                            !inputProps.small && !inputProps.large,
                        [styles.largeSelect]: inputProps.large,
                        [styles.readOnly]: !filterable,
                    }),
                    rightElement: showRightIcon ? (
                        <>
                            {additionalRightElement}
                            <FontAwesomeIcon
                                icon={selectIcon}
                                className={classNames(styles.selectIcon, {
                                    [styles.smallSelectIcon]: inputProps.small,
                                    [styles.normalSelectIcon]:
                                        !inputProps.small && !inputProps.large,
                                    [styles.largeSelectIcon]: inputProps.large,
                                })}
                            />
                        </>
                    ) : null,
                }}
            />
        )
    }
}

export default InputSelect
